import { useState, useEffect } from 'react';

export const useWidth = (element: HTMLElement | null) => {
  const [width, setWidth] = useState<number>();

  useEffect(() => {
    if (!element || typeof ResizeObserver === 'undefined') {
      return;
    }

    const measure = () => setWidth(element.getBoundingClientRect().width);
    measure();

    const resize = new ResizeObserver(measure);
    resize.observe(element);

    return () => resize.unobserve(element);
  }, [element]);

  return width;
};
